import { render, staticRenderFns } from "./news-detail.vue?vue&type=template&id=60aacfee&scoped=true"
import script from "./news-detail.vue?vue&type=script&lang=js"
export * from "./news-detail.vue?vue&type=script&lang=js"
import style0 from "./news-detail.vue?vue&type=style&index=0&id=60aacfee&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aacfee",
  null
  
)

export default component.exports